import React, { useEffect, useState } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    GetApp
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import CreateGroupCouponModal from "./form-group";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useMemo } from "react";
import couponService from "../../../services/coupon.service";
import { useErrorHandler } from "../../../hooks";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function CouponPage() {

    const errorHandler = useErrorHandler();

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await couponService.deleteCoupon(item.id);
        if(res.error){
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "name",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "code",
                title: "کدتخفیف",
                mainField: false,
            },
            {
                field: "discount",
                title: "درصدتخفیف",
                mainField: false,
            },
            {
                field: "isActiveText",
                title: "وضعیت",
                mainField: false,
            },
            {
                field: "onlyAppText",
                title: "محل استفاده",
                mainField: false,
            },
            {
                field: "order",
                title: "تعداد استفاده",
                mainField: false,
            },
        ],
        []
    );

    const handelDownloadExcel = async () => {
        const res = await couponService.getExportCoupons(search);
        // const url = window.URL.createObjectURL(new Blob([res.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "export.xlsx"); // Set the file name
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);
        // console.log(res)
    }

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await couponService.getCoupons();
        if (error) {
            // handleError(error);
            return;
        }

        setData(data.map(item => ({ 
            ...item,
            isActiveText: item.isActive ? "فعال" : "غیرفعال",
            onlyAppText: item.onlyApp ? "فقط اپلیکشن" : "آزاد",
        })));
    };

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                onRefresh={onRefresh}
                handleChangeSearchBar={setSearch}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد کد تخفیف",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد کد تخفیف گروهی",
                        modalContent: (props) => <CreateGroupCouponModal {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <GetApp />,
                        tooltip: "خروجی از کوپن ها",
                        onClick: handelDownloadExcel
                    },
                ]}
                searchKeys={defaultKeys}
                title="کد تخفیف"
            />
        </div>
    );
}
